 
 
 
 
 
 
define([], function() {
    'use strict';
    var unitTypes = {
        metric: 'metric',
        imperial: 'imperial'
    };
    return unitTypes;
});



// WEBPACK FOOTER //
// ./config/unit/unitTypes.js